import FaceMachineResuming from './FaceMachineResuming';

export default FaceMachineResuming;
